export default {
  supplierbenefits: {
    subtitle: "SUPPLIER BENEFITS",

    title1: "Why Suppliers Choose",
    title2: "MAHAL",

    desc:
      "MAHAL is designed to help suppliers grow faster, sell smarter, and build long-term partnerships with restaurants.",

    b1_title: "Direct Restaurant Access",
    b1_desc:
      "Connect directly with verified restaurants and food businesses without middlemen.",

    b2_title: "Bulk & Recurring Orders",
    b2_desc:
      "Receive consistent bulk and repeat orders that help stabilize your daily sales.",

    b3_title: "Secure & Timely Payments",
    b3_desc:
      "Transparent pricing and reliable payment cycles you can trust.",

    b4_title: "Logistics & Delivery Support",
    b4_desc:
      "Get support for delivery coordination and supply scheduling.",

    b5_title: "Business Growth Insights",
    b5_desc:
      "Track demand trends, manage inventory, and grow with data-driven insights.",

    b6_title: "Long-Term Partnerships",
    b6_desc:
      "Build trusted relationships with restaurants for sustained business growth.",

    cta: "Start Selling on MAHAL",
  },
};